// removed by extract-text-webpack-plugin
module.exports = {"classSpecifications":"Specifications-classSpecifications-ef925eaf"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/Specifications.scss
// module id = 838
// module chunks = 0